import React, { FC } from 'react';
import * as classes from './PageTitleSection.module.scss';
import Container from '../../../../../Common/Container/Container';
import cn from 'classnames';

interface Props {
  smallPadding?: boolean;
}

const PageTitleSection: FC<Props> = ({ children, smallPadding }) => {
  return (
    <section className={cn(classes.wrapper, smallPadding && classes.smallPadding)} data-aos='fade-in'>
      <Container>
        <h1>{children}</h1>
      </Container>
    </section>
  );
};

export default PageTitleSection;
